import React from "react";
import PropTypes from "prop-types";
import {CollectionIcon, DownloadIcon, PlusIcon, SwitchVerticalIcon, UploadIcon} from "@heroicons/react/outline";

const DocumentBodyToolbar = ({
    massActions,
    onAddRow,
    onOpenCatalog,
    onImport,
    importLabel,
    onExport,
    exportLabel,
    isExporting,
    addLabel,
    catalogLabel,
    onOpenReorder,
    reorderLabel,
}) => (
    <div className="flex w-full flex-wrap items-center gap-3">
        {massActions}
        {typeof onImport === "function" && (
            <button
                type="button"
                onClick={onImport}
                className="inline-flex h-8 items-center gap-2 rounded-md border border-gray-200 bg-white px-3 text-sm font-medium text-gray-600 hover:bg-gray-100"
            >
                <UploadIcon className="h-4 w-4" />
                <span>{importLabel || "Importa"}</span>
            </button>
        )}
        {typeof onOpenReorder === "function" && (
            <button
                type="button"
                onClick={onOpenReorder}
                className="inline-flex h-8 items-center gap-2 rounded-md border border-gray-200 bg-white px-3 text-sm font-medium text-gray-600 hover:bg-gray-100"
            >
                <SwitchVerticalIcon className="h-4 w-4" />
                <span>{reorderLabel || "Riordina"}</span>
            </button>
        )}
        {typeof onExport === "function" && (
            <button
                type="button"
                onClick={onExport}
                disabled={isExporting}
                aria-busy={isExporting}
                className={`inline-flex h-8 items-center gap-2 rounded-md border border-gray-200 bg-white px-3 text-sm font-medium text-gray-600 hover:bg-gray-100 ${isExporting ? "cursor-not-allowed opacity-70" : ""}`}
            >
                <DownloadIcon className="h-4 w-4" />
                <span>{exportLabel || "Esporta"}</span>
            </button>
        )}
        {typeof onAddRow === "function" && (
            <button
                type="button"
                onClick={onAddRow}
                className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-blue-1000 bg-blue-1000 text-white hover:bg-blue-900"
                aria-label={addLabel || "Aggiungi"}
                title={addLabel || "Aggiungi"}
            >
                <PlusIcon className="h-4 w-4" />
            </button>
        )}
        {typeof onOpenCatalog === "function" && (
            <button
                type="button"
                onClick={onOpenCatalog}
                className="inline-flex h-8 items-center gap-2 rounded-md border border-blue-1000 bg-white px-3 text-sm font-medium text-blue-1000 hover:bg-blue-50"
                aria-label={catalogLabel || "Catalogo"}
                title={catalogLabel || "Catalogo"}
            >
                <CollectionIcon className="h-4 w-4" />
                <span>{catalogLabel || "Catalogo"}</span>
            </button>
        )}
    </div>
);

DocumentBodyToolbar.propTypes = {
    enableSearch: PropTypes.bool,
    onSearchChange: PropTypes.func,
    searchValue: PropTypes.string,
    searchPlaceholder: PropTypes.string,
    searchResetToken: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
    massActions: PropTypes.node,
    onAddRow: PropTypes.func,
    onOpenCatalog: PropTypes.func,
    onImport: PropTypes.func,
    importLabel: PropTypes.string,
    onExport: PropTypes.func,
    exportLabel: PropTypes.string,
    isExporting: PropTypes.bool,
    addLabel: PropTypes.string,
    catalogLabel: PropTypes.string,
    onOpenReorder: PropTypes.func,
    reorderLabel: PropTypes.string,
};

DocumentBodyToolbar.defaultProps = {
    enableSearch: true,
    onSearchChange: undefined,
    searchValue: "",
    searchPlaceholder: "",
    searchResetToken: null,
    massActions: null,
    onAddRow: undefined,
    onOpenCatalog: undefined,
    onImport: undefined,
    importLabel: "",
    onExport: undefined,
    exportLabel: "",
    isExporting: false,
    addLabel: "",
    catalogLabel: "",
    onOpenReorder: undefined,
    reorderLabel: "",
};

export default DocumentBodyToolbar;
